// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2069":"a0b32d7a841ea692c585","2968":"2492f1c62a7305286f9c","3393":"0e069c7aec4a295daa91","3589":"3788027b3cef9d735be8","4127":"b6c76fb21b8f576a161e","4578":"d3dd2e46268ae99be5c1","6532":"d51f0c568e9eae3039aa"}[chunkId] + ".bundle.js";
};